module.exports = __webpack_public_path__ + "media/images/redrock/purple_front-e2a342056e6ffc36b0667ea4e5d1209b.jpg";